<template>
    <div :class="col ? 'flex-col items-stretch justify-start' : 'flex-row items-center justify-between'" class="flex">
        <div class="flex flex-col items-start justify-start" :class="col ? '' : 'w-1/2'">
            <div class="flex flex-row items-center justify-start">
                <div class="font-bold">{{ title }}</div>
                <help v-if="help" class="ml-2">{{ help }}</help>
            </div>
            <div class="text-gray-600">{{ description }}</div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
import Help from '@/components/Help'

export default {
    components: { Help },
    props: {
        title: String,
        description: String,
        help: String,
        col: {
            type: Boolean,
            default: false
        },
    }
}
</script>